import { useServerStatus } from '../hooks/useServerStatus';

export function WarmingBanner() {
  const { warming, progress, unknown } = useServerStatus(3000);

  if (unknown || !warming) return null;

  const pct = progress
    ? Math.min(
        100,
        Math.round(
          ((progress.drivers > 0 ? 25 : 0) +
           (progress.circuits > 0 ? 25 : 0) +
           (progress.constructors > 0 ? 25 : 0) +
           (progress.seasonsLoaded / Math.max(progress.totalSeasons, 1)) * 25),
        ),
      )
    : 0;

  return (
    <div className="warming-banner" role="status" aria-live="polite">
      <div className="warming-bar" style={{ width: `${pct}%` }} />
      <div className="warming-content">
        <span className="warming-dot" aria-hidden />
        <span className="warming-text">
          Loading historical data. New pages will refresh automatically.
        </span>
        {progress && (
          <span className="warming-stats">
            {progress.drivers > 0 && <span>{progress.drivers} drivers</span>}
            {progress.circuits > 0 && <span>{progress.circuits} circuits</span>}
            {progress.constructors > 0 && <span>{progress.constructors} constructors</span>}
            {progress.seasonsLoaded > 0 && (
              <span>{progress.seasonsLoaded}/{progress.totalSeasons} seasons</span>
            )}
          </span>
        )}
      </div>
    </div>
  );
}
